import type { DungeonRun } from './types'

export const WIN_BONUS = 1000
export const FLOOR_POINTS = 100
export const KILL_POINTS = 10

/** Floors fully cleared: the current floor counts only once the run is won. */
export function floorsCleared(state: Pick<DungeonRun, 'floor' | 'status'>): number {
  return state.floor - 1 + (state.status === 'won' ? 1 : 0)
}

/** The number the daily board sorts by. Higher is better; ties break on fewer turns. */
export function scoreFor(state: Pick<DungeonRun, 'floor' | 'status' | 'kills' | 'gold'>): number {
  return (
    FLOOR_POINTS * floorsCleared(state) +
    KILL_POINTS * state.kills +
    state.gold +
    (state.status === 'won' ? WIN_BONUS : 0)
  )
}

/** Stars on the run-end card: 1 for reaching floor 4, 2 for floor 7, 3 for winning. */
export function starsFor(state: Pick<DungeonRun, 'floor' | 'status'>): 0 | 1 | 2 | 3 {
  if (state.status === 'won') return 3
  const cleared = floorsCleared(state)
  if (cleared >= 6) return 2
  if (cleared >= 3) return 1
  return 0
}
